// import { SchemeTypes } from '../../../../config';
import { IIdentificationDetails } from '../../models';

interface IIdentificationFormFields {
  identificationDetails_vatNumber: string | null;
  identificationDetails_companyName: string | null;
  identificationDetails_vatReturnId: number | null;
  identificationDetails_vatReturnVersionId: number | null;
  identificationDetails_vatReturnReference: number | null;
}

export default function handleIdentificationDetailsDefaultValues(
  identification_details: IIdentificationDetails
): IIdentificationFormFields {
  return {
    identificationDetails_vatNumber: identification_details.vat_id_num ?? null,
    identificationDetails_companyName:
      identification_details.company_name ?? null,
    identificationDetails_vatReturnId:
      identification_details.vat_return_id ?? null,
    identificationDetails_vatReturnVersionId:
      identification_details.vat_return_version_id ?? null,
    identificationDetails_vatReturnReference:
      identification_details.vat_return_reference ?? null,
  };
}
